import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { UsuarioAdminLoginResponse } from '../../responses/usuario-admin/usuario-admin-login.response';

import { SocialAuthService } from '@abacritt/angularx-social-login';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private socialAuthService: SocialAuthService,
    @Inject(DOCUMENT) private _doc: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    super();
  }

  public signInWithGoogle(token: string, ip: string): Observable<any> {
    const userAuthRequest = {
      token: token,
      ip: ip,
    };

    return this.httpClient
      .post<any>(environment.urlApiUsuarioAdmin + 'Auth', userAuthRequest)
      .pipe(catchError(this.handleError));
  }

  updateToken(userLoginResponse: UsuarioAdminLoginResponse): void {
    this._doc.defaultView?.sessionStorage?.setItem('token', JSON.stringify(userLoginResponse));
  }

  getToken(): string {
    const token = window?.sessionStorage?.getItem('token');
    if (token) {
      const userLoginResponse: UsuarioAdminLoginResponse = JSON.parse(token);
      return userLoginResponse.token;
    }
    return '';
  }

  getUserInfos(): UsuarioAdminLoginResponse {
    if (isPlatformBrowser(this.platformId)) {
      const token = window?.sessionStorage?.getItem('token');
      if (!token) {
        return this.getDefaultUser();
      }
      const userLoginResponse: UsuarioAdminLoginResponse = JSON.parse(token);
      return userLoginResponse;
    }
    return this.getDefaultUser();
  }

  private getDefaultUser(): UsuarioAdminLoginResponse {
    return {
      isError: false,
      errorCode: 0,
      errorDescription: '',
      idUsuarioAdmin: 0,
      nomeUsuarioAdmin: '',
      email: '',
      cpf: '',
      listaPermissoes: [],
      listaModulos: [],
      listaFuncionalidades: [],
      master: false,
      token: '',
    };
  }

  logout(): void {
    this._doc.defaultView?.sessionStorage?.removeItem('token');
    this.socialAuthService.signOut();
    this.router.navigate(['/']);
  }

  isAuthenticated(): boolean {
    return !this._doc.defaultView?.sessionStorage?.getItem('token') ? false : true;
  }
}
